import { Component, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { CovanceFilterBaseTypeComponent } from './covance-filter-base-type.component';
import { CovanceFilterSelectType } from './covance-filter-select-type';
import { Subscription } from 'rxjs';

@Component({
    selector: 'covance-filter-select-type',
    template: require('./covance-filter-select-type.component.html'),
    styles: [require('./filter-common-style.scss')]
})
export class CovanceFilterSelectTypeComponent extends CovanceFilterBaseTypeComponent<CovanceFilterSelectType> implements OnDestroy {

    private readonly subscription: Subscription;

    constructor(filterType: CovanceFilterSelectType, ref: ChangeDetectorRef) {
        super(filterType);
        this.subscription = filterType.changeDetector.subscribe(_ => ref.markForCheck());
    }

    public getItems() {
        return this.fieldVal.items ? this.fieldVal.items : [];
    }

    public hasItems() {
        return this.fieldVal.items && this.fieldVal.items.length > 0;
    }

    public ngOnDestroy() {
        this.subscription.unsubscribe();
    }
}